import axios from "axios";

class IngDeskService {
  async getIngDeskToken(baseUrl, loginUser) {
    try {
      let token = null;
      const data = {
        login_user: loginUser,
        login_master: "ingenium",
        password_master: "52e9f8a1500604b372a5c0908d93ee5f",
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const response = await axios.post(
        `${baseUrl}/login-master-integrationv3`,
        data,
        config,
      );
      const hasResponse = !!response && response.status === 200;
      if (hasResponse) {
        const deskData = response.data;
        const hasDeskData = !!deskData;
        if (hasDeskData) {
          token = deskData.token;
        }
      }

      return token;
    } catch (error) {
      console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    }
  }

  async insertOrUpdateContact(data, baseUrl, token) {
    try {
      const config = {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(
        `${baseUrl}/upsert-contact-enterprise`,
        data,
        config,
      );

      return response;
    } catch (error) {
      console.log("IngDeskService-insertOrUpdateContact erro: ", error);
    }
  }

  async insertInteractionContact(data, baseUrl, token) {
    try {
      const config = {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(
        `${baseUrl}/inserir-interacao-contato`,
        data,
        config,
      );

      return response;
    } catch (error) {
      console.log("IngDeskService-insertInteractionContact erro: ", error);
    }
  }

  async getGiroStatusByCdr(cdr, baseUrl, token) {
    try {
      const config = {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.get(
        `${baseUrl}/get-giro-status-by-cdr/${cdr}`,
        config,
      );
      return response;
    } catch (error) {
      console.log("getGiroStatusByCdr Error: ", error);
    }
  }

  async getContatoGiroCarteira(telefone, baseUrl, token) {
    try {
      const config = {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.get(
        `${baseUrl}/get-contato-giro-carteira?telefone=${telefone}`,
        config,
      );

      return response;
    } catch (error) {
      console.log("getContatoGiroCarteira Error: ", error);
    }
  }

  async getIngDeskDataOfUser(baseUrl, loginUser) {
    try {
      let dataOfUser = {
        token: null,
        userIdInIngDesk: null,
      };
      const data = {
        login_user: loginUser,
        login_master: "ingenium",
        password_master: "52e9f8a1500604b372a5c0908d93ee5f",
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const response = await axios.post(
        `${baseUrl}/login-master-integrationv3`,
        data,
        config,
      );
      const hasResponse = !!response;
      if (hasResponse) {
        const deskData = response.data;
        const hasDeskData = !!deskData;
        if (hasDeskData) {
          dataOfUser.token = response.data.token;
          const hasUserData =
            Array.isArray(response.data.dados) &&
            response.data.dados.length > 0;
          if (hasUserData) {
            dataOfUser.userIdInIngDesk = response.data.dados[0].id_usuario;
          }
        }
      }

      return dataOfUser;
    } catch (error) {
      console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    }
  }

  async ListarGiroCarteiraMetricas(idChannel, baseUrl, token) {
    try {
      const config = {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.get(
        `${baseUrl}/listar-giro-carteira-metricas?id_canal=${idChannel}`,
        config,
      );

      return response;
    } catch (error) {
      console.log("ListarGiroCarteiraMetricas Error: ", error);
    }
  }

  async setSucessoGiroPorCdr(cdr, baseUrl, token) {
    try {
      const config = {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.put(
        `${baseUrl}/set-sucesso-giro-por-cdr/${cdr}`,
        undefined,
        config,
      );

      return response;
    } catch (error) {
      console.log("setSucessoGiroPorCdr Error: ", error);
    }
  }

  async getIngDeskIdProfile(baseUrl, loginUser) {
    try {
      let profileInfos = {
        idProfile: null,
        token: null,
        idTipo: null,
      };
      const data = {
        login_user: loginUser,
        login_master: "ingenium",
        password_master: "52e9f8a1500604b372a5c0908d93ee5f",
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const response = await axios.post(
        `${baseUrl}/login-master-integrationv3`,
        data,
        config,
      );
      const hasResponse = !!response;
      if (!hasResponse) return profileInfos;
      const hasData =
        Boolean(response.data) &&
        Array.isArray(response.data.dados) &&
        response.data.dados.length > 0;
      if (!hasData) return profileInfos;
      profileInfos.idProfile = response.data.dados[0].id_perfil;
      profileInfos.token = response.data.token;
      profileInfos.idTipo = response.data.dados[0].id_tipo;
      return profileInfos;
    } catch (error) {
      console.log("ERRO AO CARREGAR REQUISIÇÃO getIngDeskIdProfile:", error);
    }
  }

  async getPermissions(baseUrl, idProfile, token) {
    try {
      const config = {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.get(
        `${baseUrl}/user-profile?id_perfil=${idProfile}`,
        config,
      );

      return response;
    } catch (error) {
      console.log("getPermissions Error: ", error);
    }
  }
}

export const ingDeskService = new IngDeskService();
